const apis = {
  initWx: '/c0/wx/config', // 初始化
  homeApi: '/c0/view/home', // 主页资源接口
  configApi: '/c0/config/home', // 主页配置接口
  userInfo: '/vod/coupon/user',
  // homeInfo: '/vadd/gzh/home/info',
  upload: '/by/upload', // 上传图片
  upyun: '/autodynemv',
  song: '/bar/u/remote_ctrl/song/', // 播放控制
  mv: '/vod/mv',
  theme: '/vod/theme', // 主题
  emoji: '/vod/emoji', // 表情
  group: '/vod/emoji/group', // 弹幕分组
  upload_songs: '/u/upload/songs', // 录音列表
  upload_song: '/u/upload/song', // 单个录音
  list: '/bar/u/remote_ctrl/song/list', // 列表
  orderSong: '/vod/song/order',
  top: '/vod/song/listtop', // 置顶
  play: '/bar/u/remote_ctrl/song/', // 播放控制
  dict: '/bar/u/remote_ctrl/dict/v2', // 语音字典
  top_type: '/vadd/gzh/home/hot',
  singer_list: '/bar/u/remote_ctrl/song/getsingerlist', // 歌星列表
  balance: '/vod/coupon/user/balance', // 获取账户余额
  blessv1: '/c1/bless/home/old/v1', // 霸屏祝福第一版初始化
  blessv4: '/c1/bless/home/new/v1', // 第三版霸屏祝福初始化数据接口
  blessv1_wpay: '/c1/bless/wxpay/old/v1', // 霸屏祝福v1微信支付
  blessv1_pay: '/c1/bless/cppay/old/v1', // 霸屏祝福v1余额支付
  blessv4_wpay: '/c1/bless/wxpay/new/v1', // 霸屏祝福v4微信支付
  blessv4_pay: 'c1/bless/cppay/new/v1', // 霸屏祝福v4余额支付
  baochang_wpay: '/c1/baochang/wxpay', // 包场微信支付
  bless_new_free_pay: 'c1/bless/send/new/v1', // 购买包场后免费发送新版祝福
  bless_old_free_pay: 'c1/bless/send/old/v1', // 购买包场后免费发送老版祝福
  photo_new_free_pay: 'c1/photo/send/new/v1', // 购买包场后免费发送新版照片
  photo_old_free_pay: 'c1/photo/send/old/v1', // 购买包场后免费发送老版照片
  photov1: '/c1/photo/home/old/v1', // 老版照片祝福获取页面资源
  photov2: '/c1/photo/home/new/v1', // 新版照片获取页面资源
  photo_pag: '/c1/photo/home/new/v2', // 支持pag格式照片页面获取资源
  photov1_pay: '/c1/photo/cppay/old/v1', // 老版照片祝福余额支付接口
  photov1_wpay: '/c1/photo/wxpay/old/v1', // 老版照片祝福微信支付接口
  photov2_pay: '/c1/photo/cppay/new/v1', // 新版照片祝福余额支付接口
  photov2_wpay: '/c1/photo/wxpay/new/v1', // 新版照片祝福微信支付接口
  getChargePackage: '/vod/coupon/price', // 获取充值套餐信息
  getChargeOrder: '/vod/coupon/order', // 购买充值服务
  mvTheme: '/vod/theme', // 获取照片mv主题
  mvsong: '/bar/u/remote_ctrl/search/mvsong', // 搜索照片mv歌曲
  dynemv: '/autodynemv', // 上传图片
  song_list: '/vadd/gzh/home/list',
  adoptHome: '/vodc/adopt/home', // 新版冠名页推荐歌单
  adoptSong: '/vodc/adopt/song', // 新版冠名页我要冠名
  adoptMySong: '/vodc/adopt/songlist', // 新版冠名页我的冠名
  adoptModify: '/vodc/adopt/modify', // 新版冠名页我的冠名修改
  adoptSearch: '/c/adopt/song/search/v5', // 冠名搜索
  myNaming: '/vod/adopt/song/main/v4', // 我的冠名
  newAdoptAll: '/c/adopt/list/price/v5',
  newAdoptNew: '/c/adopt/list/time/v5',
  newMyNaming: '/c/adopt/list/my/v5',
  newAdoptHot: '/c/adopt/song/hot',
  newAdoptRicher: '/c/adopt/song/richer',
  feedback: '/vadd/gzh/feedback', // 意见反馈
  search_singer: '/vodc/home/singer', // 根据歌星搜索歌曲
  search_singer1: '/vodc/home/singer/v2', // 根据歌星id搜索歌曲
  song_likev2: '/vadd/gzh/home/my_song', // 常唱歌曲需求变更
  adopt_pay: '/c/adopt/cppay/v5',
  adopt_wpay: '/c/adopt/pay/v5',
  search_home: '/vodc/home/search', // 冠名新列表首页搜索
  search_v2: '/vodc/home/search/v2', // 点歌台搜索页接口
  search_v3: '/vodc/home/search/v3', // 点歌台搜索页接口
  topList: '/vodc/home/top', // 歌曲榜单
  appmusic: '/vod/appmusic/index', // 导入歌单
  deleteMusic: '/vod/appmusic/delete', // 删除歌单
  vipPay: '/vodc/vip/wxpay', // 购买vip
  vipPackages: '/vod/vip/price/v2', // vip套餐信息
  vipExperiment: '/vodc/vip/experiment/wxpay', // 体验会员
  vipCrabPay: '/vodc/vip_crab/wxpay', // 一日会员
  nearbyList: '/vod/nearby/list', // 附近的人列表
  nearbyContent: '/vod/nearby/content',
  nearbyKtvContentList: '/vod/nearby/ktv/content/list',
  nearbyKtvList: '/vod/nearby/ktv/list',
  nearbyDelete: '/vod/nearby/delete',
  nearbySend: '/vod/nearby/cppay',
  nearbyReplyList: '/vod/nearby/reply',
  drinkQuit: '/vod/game/drink/quit',
  drinkPlayer: '/vod/game/drink/players',
  drinkStart: '/vod/game/drink/start',
  barrage: '/vod/bullet/package', // 弹幕套餐
  sendBarrage: '/vod/bullet/say', // 发送弹幕
  barrageAuth: '/vod/bullet/auth', // 查询用户是否可以发弹幕
  deleteOrdered: '/bar/u/remote_ctrl/song/delete',
  allTops: 'vodc/home/tops',
  sendGift: '/vod/gift/cppay', // 发送礼物
  getGift: '/vod/gift/list', // 获取礼物列表
  getPagGift: '/vod/gift/list/v2', // 获取pag礼物列表
  giftWxPay: '/vod/gift/wxpay',
  appmusicDetail: '/vod/appmusic/detail',
  deleteMySong: '/vadd/gzh/home/my_song_del', // 删除我的常唱
  qiniuToken: '/c/qiniu/get_upload_token', // 七牛获取token接口
  sendVideoTimes: '/vod/video/times',
  nationalHome: '/vod/activity/home', // 国庆活动
  nationalFinish: '/vod/activity/finish',
  shareCode: '/vod/invite/qrcode',
  rankSongDetail: '/c/lsk/work', // 作品详情
  rankPrice: '/c/lsk/price', // 人气值价格信息
  rankScoreFree: '/c/lsk/score/free', // 免费点赞
  rankScore_wpay: '/c/lsk/score/gzhpay', // 人气值微信支付
  rankhistory: '/c/lsk/history', // 往期列表
  ranksonglist: '/c/lsk/songs', // 我的录音列表
  rankHome: '/c/lsk/home', // 首页信息
  rankTop: '/c/lsk/rank', // 榜单查询
  rankUser: '/c/lsk/user/contact', // 联系方式
  rankJoin: '/c/lsk/works', // 我的参赛作品列表
  activityOver: '/c2/ball/date', // 活动是否结束
  weekHome: '/c1/weektop/home',
  weekPay: '/c1/weektop/wxpay',
  weekSend: '/c1/weektop/send',
  giftSend: '/c1/gift/send',
  getIntegral: '/c1/integral/home',
  integralPay: '/c1/integral/pay',
  integralrecord: 'c1/integral/record',
  integralexchange: 'c1/integral/exchange/record',
  getDataCommonApi: '/cms/kv',
  sendPub: '/pub', // 发送聊天消息
  maibaOrderSong: '/c1/mid/order',
  baochangInfo: '/c1/baochang/info', // 包场信息
  getGzhMatch: '/vodc/gzh/match',
  getFreeGiftCount: '/vodc/gift/free/count',
  sendFreeGift: '/vodc/gift/free/send',
  getLikeSong: '/song/user/songnum',
  getYourLike: '/recom/recom_song',
  goldBaochang: '/vodc/baochang-jz/info',
  goldBaochangWxpay: '/vodc/baochang-jz/wxpay',
  qr_code: '/vodc/freevip/qr',
  getIsVip: '/vodc/user/vip',
  autoOrderSong: '/vodc/mls/userAuto',
  creatMyList: '/vodc/mls/my_list/add',
  editMyList: '/vodc/mls/my_list/update',
  getAllMyList: '/vodc/mls/my_list/all',
  delMyList: '/vodc/mls/my_list/del',
  getMyList: '/vodc/mls/my_list/song/list', // 歌单歌曲列表
  getMyListRole4: '/vodc/lately/songs/expired', // 老用户最近演唱
  getMyOftenSong: '/vodc/home/cc/v2', // 我的常唱
  delListSong: '/vodc/mls/my_list/songs/del',
  addListSong: '/vodc/mls/my_list/songs/add',
  gmSwitch: '/c/adopt/active/half', // 冠名活动开关
  gmscrolling: '/c/adopt/order/list',
  squareNews: '/vodc/ktv/user/list',
  sendSquareNews: '/vodc/ktv/message/send',
  checkSquareNews: '/vodc/ktv/message/receive',
  getMyNews: '/vodc/ktv/message/my',
  getScreenNewsStatus: '/vodc/ktv/message/switch',
  sendMotto: '/vodc/ktv/user/motto',
  singlePoint: '/vodc/wuqu/wxpay', // 单点支付
  getUserLotteryTimes: '/vodc/vip/lottery/active', // 我的页抽奖次数
  VipLotteryReceicePrice: '/vodc/vip/lottery/active/award', // 我的页抽奖领取奖品
  getOrderList: '/vod/scrollbar/list',
  xiaoaiBlessPay: '/vodc/photobless/xiaoai/wxpay', // 小爱祝福单次支付
  xiaoaiBlessPush: '/vodc/photobless/xiaoai/send', // 发送小爱祝福
  giftPayment: '/vod/gift/nvip/pay', // 大屏礼物按次数收费
  presentVipStatus: '/vodc/send/vip', // 查询赠送vip状态信息
  receiveVip: '/vodc/receive/vip', // 接收赠送vip状态信息
  getBeatSong: '/vodc/home/vip/accompany', // 获取VIP伴奏弹窗信息
  getNewYearSong: '/vodc/home/newyear/top', // 新年欢唱榜单
  getTabList: '/vodc/mls/my_list/all/v2', // 获取歌单tab列表
  delSonglist: '/vodc/mls/my_list/songs/update', // 删除歌单歌曲
  souyudiancanLog: '/vodc/diancan/log', // 搜娱点餐数据上报
  singleRightsPay: '/vodc/solo/baochang/wxpay', // 单人包场微信支付
  singleRightsInfo: '/vodc/solo/baochang/info', // 单人包场
  discoPay: '/vodc/disco/wxpay', // 蹦迪模式支付
  discoStart: '/vodc/disco/start', // 蹦迪模式是否开通
  discoClear: '/vodc/disco/clear', // 清楚蹦迪模式
  syncEnterEffect: '/vodc/mpage/set', // 同步手机端用户的VIP进场特效选择
  experienceVIP: '/vodc/free/vip/minute', // 免费领取1分钟VIP
  bargainVIP: '/vodc/vip/diy/wxpay', // 议价VIP
  giftSpoof: 'vod/gift/list/spoof', // 恶搞整蛊礼物素材
  spoofSend: '/vod/gift/spoofsend', // 恶搞整蛊礼物免费发送
  getPrivilege: '/vodc/privilege/info', // 获取用户权益信息 (暂时不用)
  privilegeWxpay: '/vodc/privilege/wxpay', // 权益支付
  photo_pagv3: '/vodc/photo/home/new/v3', // 垃取pag版照片资源
  bless_pagv3: '/vodc/bless/home/new/v3', // 垃取pag版祝福资源
  photo_pag_free: '/vodc/photo/send/new/v4', // 购买vip/权益后发照片
  bless_pag_free: '/vodc/bless/send/new/v4', // 购买vip/权益后发祝福
  pngPrivilege: '/vodc/png/home/v3', // png版权益信息
  pngSendPhotos: '/vodc/photo/send/new/pngv4', // png版发多张照片
  pngSendPhoto: '/vodc/photo/send/old/pngv4', // png版发单张照片
  pngSendBless: '/vodc/bless/send/new/pngv4', // png版发祝福
  freeOpenGold: '/vodc/vip/invite/activity ', // 0元开通金主
  getClassifiedSongs: '/vodc/song/topics', // 一级分类
  getSongsMenu: '/vodc/topic/songlist', // 分类下歌单
  getMenuSongList: '/vodc/song/list', // 除我的常唱外歌单下歌曲
  getSelectedSongs: '/vodc/song/list/jx', // 精选榜单
  getTopsHome: '/vodc/song/top/home', // 排行榜首页
  getTopSong: '/vodc/song/top/songs', // 排行榜歌曲列表
  getHotWord: '/vodc/home/hotword', // 搜索发现
  getHotTop: '/vodc/home/hottop', // 搜索推荐榜单
  lkvipPackages: '/vodc/lkvip/home', // 获取雷客点歌机VIP充值项
  lklinuxvipPackages: '/vodc/linuxvip/home', // 获取雷客点歌机linuxVIP充值项
  lkvipPay: '/vodc/lkvip/wxpay', // 雷客VIP支付
  linuxvipPay: '/vodc/linuxvip/wxpay', // linuxVIP支付
  lkcode: '/vod/p/lkvip', // 雷客VIP商家码，进行授权使用
  aiGiftPrivilege: '/vodc/ai/home', // ai礼物页权益信息
  leikeInfo: '/vodc/mylk/home', // 我的页雷客信息
  leikeInfo2: '/vodc/mylk/home2', // 搜索页雷客信息
  configGetrole: '/vodc/config/getrole', // 更新用户身份信息
  // AI作品页
  getAiListConfig: '/vodc/aizz/photo/user',
  deleteAiTasks: '/vodc/aizz/photo/tasks/del',
  // AI写真
  // 首页素材与套餐信息
  getAiPhotoConfig: '/vodc/aizz/photo/material',
  sendAiPhotoTask: '/vodc/aizz/photo/task',
  sendAiPhoto: '/vodc/aizz/photo/send',
  // 明星合照
  getStarPhotoConfig: '/vodc/vadd/starphotos/home',
  sendStarPhotoTask: '/vodc/vadd/starphotos/task',
  sendStarPhoto: '/vodc/vadd/starphotos/send',
  // 新年壁纸
  getWallpaperConfig: '/vodc/vadd/wallpaper/homev2',
  getWallpaperDown: '/vodc/vadd/wallpaper/down',
  payWallpaper: '/vodc/vadd/wallpaper/wxpay',
  payWallpaperCb: '/vodc/vadd/wallpaper/paycb',
  // 新年表情
  getEmojiConfig: '/vodc/vadd/emoji/home',
  payEmoji: '/vodc/vadd/emoji/wxpay',
};
export default apis;
